<div class="container propertiesDrawerWrapper">
  <div class="DrawerHeader">
    <h2>{{selectedProperty?.id ?  trans.Property + ' > ' + selectedProperty?.name : trans.CreateProperty | translate}}</h2>

    <div class="header-controls">
      <button [disabled]="propertiesForm.invalid || !isEdited" *ngIf="!selectedProperty?.id" class="btn-icons"
        type="button" customTooltip="{{ trans.SaveAndAddNew }}" [ngClass]="{'disabled': (propertiesForm.invalid || !isEdited)}"
        (click)="addProperty()">
        <mat-icon aria-label="Save & Add New">plus_one</mat-icon>
      </button>
      <button [disabled]="propertiesForm.invalid || !isEdited"
        *ngIf="!isModelPage || !selectedProperty?.componentInstanceId"
        [ngClass]="{'disabled': (propertiesForm.invalid || !isEdited)}" class="btn-icons" type="button"
        customTooltip="{{ trans.AddAndClose }}" (click)="addProperty(true)">
        <mat-icon aria-label="Add and close">check</mat-icon>
      </button>
      <button class="btn-icons" type="button" (click)="dismiss()" customTooltip="{{ trans.Close }}">
        <mat-icon aria-label="close">close</mat-icon>
      </button>
    </div>
  </div>

  <div class="drawerBody">
    <mat-tab-group class="matTabsTags">
      <mat-tab>
        <div fxFlex="row" fxLayoutAlign="space-between center" *ngIf="isAssetsPage">
          <div fxFlex="48" class="is-override">
            <div *ngIf="!selectedProperty?.isOverride; else resetToDefault" fxFlex="48">
              <mat-slide-toggle [formControl]="isOverrideControl" color="primary" style="max-width: unset"> Override
              </mat-slide-toggle>
            </div>
            <ng-template #resetToDefault>
              <button mat-raised-button class="save" color="accent" (click)="onResetProperty()">{{ trans.ResetToDefault | translate }}</button>
            </ng-template>
          </div>
        </div>

        <form [formGroup]="propertiesForm" class="formDetils">
          <mat-form-field appearance="outline">
            <mat-label> {{ trans.Name | translate }}</mat-label>
            <input type="text" matInput formControlName="name" [matAutocomplete]="auto" appAutoFocus required
              pattern="^[a-zA-Z]([a-zA-Z0-9_/-\s_.])+$" maxlength="40" (input)="onNameInput($event.target.value)" />
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onNameInput($event.option.value)">
              <mat-option *ngFor="let filteredPropertyName of filteredPropertyNames | async"
                [value]="filteredPropertyName.name">
                {{ filteredPropertyName.name }}
              </mat-option>
            </mat-autocomplete>

            <mat-error *ngIf="propertiesForm.get('name').errors?.duplicate" class="m-t-15">
           {{ trans.NameAlreadyExists | translate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="m-b-15 m-t-10">
            <mat-label>           {{ trans.PropertyType | translate }}
            </mat-label>
            <mat-select formControlName="dataTypeId" (selectionChange)="propTypeChanged()">
              <!-- <mat-option value="">Select</mat-option> -->
              <mat-option [id]="prop.id" *ngFor="let prop of propertyTypes" [value]="prop.id">
                {{ prop.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div *ngIf="selectedPropertyType?.name">
            <mat-form-field appearance="outline"
              *ngIf="selectedPropertyType.id !== '31c9386f-e793-4ff0-9e20-31f947c6b2db'">
              <mat-label>{{ trans.Value | translate }} </mat-label>
              <input matInput formControlName="text" autocomplete="off" />
            </mat-form-field>
          </div>

          <mat-form-field appearance="outline"
            *ngIf="selectedPropertyType.id === '31c9386f-e793-4ff0-9e20-31f947c6b2db'">
            <mat-label> {{ trans.SelectDate | translate }}</mat-label>
            <input matInput formControlName="dateTime" [matDatepicker]="picker" (click)="picker.open()" readonly>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker [disabled]="selectedProperty.disableDeleteAction && !isOverride"></mat-datepicker>
          </mat-form-field>

        </form>
      </mat-tab>
      <!-- <mat-tab label="Permissions"></mat-tab>
      <mat-tab label="Visibility"></mat-tab> -->
    </mat-tab-group>
  </div>
</div>